window.addEventListener("DOMContentLoaded",async () => {

    try {
        // Seteamos las variables

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let locale = "";

        //textos de los diferentes idiomas
        let localeTexts = {
            en: {
                button: "BikiniScan",
                recommendation: "We recommend you size",
                result: "Scanning process finished successfully",
                beforeText: "Not sure about your size? Let us recommend you",
                recommendPage: "Would you like to see more products that fits you?",
                recButton: "See more",
                statistics: "",
                statistics2: "% of people with your sizes are size",
                continue: "Continue Shopping"

            },
            es: {
                button: "BikiniScan",
                recommendation: "Te recomendamos la talla",
                result: "El proceso de escaneado finalizó correctamente",
                beforeText: "¿No estás seguro sobre tu talla? Te ayudamos a encontrarla.",
                recommendPage: "¿Te gustaría ver más productos que se ajusten a tu cuerpo?",
                recButton: "Ver mas",
                statistics: "El ",
                statistics2: "% de las personas con tus medidas son talla",
                continue: "Seguir comprando"
            }
        }



        if (urlParams)
            if (!urlParams.get("dev") == 1) {

                let lStorage = window.localStorage;
                let detectorFrame = null;
                let userInfo;

                //setear usuario en local storage
                let setUserInfo = (id) => {
                    lStorage.setItem("edData", id);
                }

                //chequeamos los parametros
                if (urlParams) {

                    //seteamos el ID
                    if (urlParams.get("userId")) {
                        const userId = urlParams.get("userId");
                        setUserInfo(userId)
                    }

                    //seteamos el idioma
                    if (urlParams.get("locale")) {
                        locale = urlParams.get("locale");
                    }

                }

                if (locale == "")
                    locale = window.Shopify.locale;
                let getProductData = async (handle) => {
                    const result = fetch(`https://encantadore.com/products/${handle}.json`, {
                        method: 'GET',
                        mode: 'cors'
                    });

                    let data = await result.then(response => response.json());
                    //console.log(data);
                    return data;
                }
                //Traemos los dataos de un JSON que trae Shopify
                let productData = JSON.parse(document.getElementById("ProductJson-product-template").innerText);
              	console.log(productData);
                	const handle = productData.title.replace(" &","").split(" ").map(word=>word.replace(/\W/ig,'')).join("-").toLowerCase()
                                      
					productData = (await getProductData(handle)).product;
                
                //URL del iframe
                //let frameURL = `https://nahuel.estylar.com/scan-process?language=${locale}&redirect=1`;
                let frameURL = `https://encantadore-detector.estylar.com/scan-process?language=${locale}&redirect=1&productId=${productData.id}`;

                //URL para chequear el origen del mensaje del iframe
                let frameOrigin = "https://encantadore-detector.estylar.com"
                //let frameOrigin = "https://nahuel.estylar.com"


                //Objeto del DOM donde vamos a poner el botón con el modal y el iframe
                let econtainer = document.getElementById("eContainer");

                //HTML para insertar en el contenedor
                eContainer.innerHTML = `
        <div id="estylarDetector">
		  <div id="detectorBefore" class="detectorBefore">
			${localeTexts[locale].beforeText}
		  </div>
          <div class="buttonContainer">          
	          <button type="button" id="checkBtn" class="btn">${localeTexts[locale].button}</button> <div id="sizeText" class="sizeText"></div>

		  </div>
		</div>
          <div id="myModal" class="emodal">
            <div id="frameContainer" class="emodal-content">
            <span class="eclose">&times;</span>
            <div id="result" class="resultModal"></div>
            </div>
          </div>
        </div>
`

                let frameContainer = document.getElementById("frameContainer");
                let estylarDiv = document.getElementById("estylarDetector");
                let sizeText = document.getElementById("sizeText");


                let modal = document.getElementById("myModal");
                let btn = document.getElementById("checkBtn");
                let span = document.getElementsByClassName("eclose")[0];




                //Abrir el modal
                btn.onclick = function () {
                    openDetector();
                    modal.style.display = "block";
                }


                //Cerra el modal al clickear la X
                span.onclick = function () {
                    closeModal();
                }

                //Cerrar el modal al clickear fuera de él
                window.onclick = function (event) {
                    if (event.target == modal) {
                        closeModal();
                    }
                }

                //Listener del mensaje con los datos del usuario
                window.addEventListener("message", async (event) => {
                    console.log(event.origin);
                    if (event.origin !== frameOrigin)
                        return;
                    let data = event.data;
                    console.log(data);
                    if (data == "ready")
                        document.getElementById('detectorFrame').contentWindow.postMessage(window.location.href, frameURL);
                    else {
                      console.log(data)
                        data = JSON.parse(data);
                        setUserInfo(data["_id"]);
                        closeModal()
                        let modalResult = await getUserInfo();
                        // showResult(modalResult, data.hasShortScan);
                    }
                }, false);


                //Funcion para abrir el detector
                let openDetector = () => {
                    if (!detectorFrame) {
                        detectorFrame = document.createElement("iframe");
                        detectorFrame.id = "detectorFrame";
                        detectorFrame.setAttribute("allow", `camera ${frameOrigin}`);
                        detectorFrame.src = frameURL;
                        frameContainer.appendChild(detectorFrame);
                    }
                }

                //Función para cerrar el detector
                let closeModal = () => {
                    frameContainer.removeChild(detectorFrame);
                    detectorFrame = null;
                    document.getElementById("result").style.display = "none";
                    modal.style.display = "none";
                    frameContainer.className = "emodal-content"
                }

                //Trae los datos del usuario desde el endpoint de nahue
                let getUserInfo = async () => {
                    const data = lStorage.getItem("edData");
                    if (data) {
                        //console.log(`https://encantadore-size.estylar.com/get-size?userId=${userInfo["_id"]}&productSku=${pID}`);
                        //const result = fetch(`https://nahuel.estylar.com/get-size?userId=${data}&productSku=${productData.id}`,{
                        const result = fetch(`https://encantadore-sizes.estylar.com/get-size?userId=${data}&productSku=${productData.id}`, {
                            method: 'GET',
                            mode: 'cors'
                        });
                        let size = await result.then(response => response.json());
                      	
                        showSize(size[0]);
                        console.log(size);
                        return size;
                    }
                }

                //Muestra la sugerencia de talle y lo elige de ser posible
                let showSize = (size) => {
                    try {
                        let percentage = "";
                        if (Math.floor(size.score * 100) > 80) {
                            percentage = `${localeTexts[locale].statistics}${Math.floor(size.score * 100)} ${localeTexts[locale].statistics2}`
                        }
                        sizeText.innerHTML = `${localeTexts[locale].recommendation} ${size.size.name}<br/> ${percentage} `;
                        document.getElementById(`${meta.product.id}-0-${size.size.name.toLowerCase()}`)?.click()
                    } catch (ex) {
                        console.log(ex);
                    }

                }

                let showResult = (size, shortScan) => {
                    document.getElementById("result").style.display = "flex";
                    detectorFrame.style.display = "none";
                    frameContainer.className = "emodal-content eMessage"
                    let resultHTML = `
	<img src="https://cdn.shopify.com/s/files/1/0552/7270/2133/files/Encantadore_ReBrand_logo_sand-08.png" style="width:400px;"/>	
	<div style="margin-bottom: 20px; text-align:centar;">	
	<span>${!shortScan ? localeTexts[locale].result : ""}</Span>
    </div>
    <div >
        <span>${localeTexts[locale].recommendation}</span> <span>${size.size.name}</span>      
    </div>

    <div class="toRecommend">
      <span>${localeTexts[locale].recommendPage}</span>      
    <a>	
        <button style="margin-top:40px;" type="button" id="continueBtn" class="btn">${localeTexts[locale].continue}</button>	
	</a>  
    </div>`;

                    let resultTag = document.getElementById("result");
                    resultTag.innerHTML = resultHTML;


                    let continueBtn = document.getElementById("continueBtn");
                    continueBtn.onclick = function () {
                        closeModal();
                    }
                }

                getUserInfo();
            }
    } catch (ex) {
        console.log("Warning: " + ex);
    }

})